// extracted by mini-css-extract-plugin
export default {"button":"styles_button__7YEDZ","active":"styles_active__hS1wi","deactivate":"styles_deactivate__cGZd4","title":"styles_title__L+4hy"};